const main = 'calls'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
}

const routes = {
  List: `/${main}`,
}

const CallsRoutes = { ...relativeRoutes, ...routes }

export default CallsRoutes
